export const ValidationMixin = {
  data () {
    return {
      errors: []
    };
  },

  methods: {
    doValidation() {
      if (this.$store.getters.getCurrentLevel === 3) {
        var allLevel3Available = true;

        this.$store.getters.getSelectedItem.includedProducts().forEach(product => {
          if (!(this.boxQty <= this.$store.getters.getSelectedItem.maxBoxQtyLevel3Product(this.$store, product) || (product.custom_delivery_qty.allow_backorders === 'ja' && this.boxQty >= 20))) {
            allLevel3Available = false;
          }
        });

        // Level 3 product is not available for the box quantity
        if (!allLevel3Available) {
          this.errors.push({
            type: 'warning',
            message: 'Eines der Produkte ist nicht in der gewünschten Menge verfügbar. Um die Bestellung abzuschließen, löschen Sie bitte dieses Produkt oder ersetzen Sie es durch ein anderes.',
            context: {
              module: 'present',
            }
          });
        }
      }

      // No postcard mode
      if (this.$store.getters.getComposerModules.postcard.main.mode === null || (this.$store.getters.getComposerModules.postcard.main.mode === 4 && this.boxQty < this.$store.getters.getOrderQtySize.sm.min)) {
        this.errors.push({
          type: 'error',
          message: 'Bitte wählen Sie eine Option für die Grußkarten.',
          context: {
            module: 'postcard',
          }
        });
      }
      // No postcard selected
      if (this.$store.getters.getComposerModules.postcard.main.mode === 1 && (this.$store.getters.getComposerModules.postcard.motive.mode === null || this.$store.getters.getComposerModules.postcard.motive.mode === 0)) {
        this.errors.push({
          type: 'error',
          message: 'Bitte wählen Sie ein Grußkartenmotiv.',
          context: {
            module: 'postcard',
            anchor: '_ModulePostcardMotive'
          }
        });
      }

      // No postcard message mode
      if (this.$store.getters.getComposerModules.postcard.main.mode === 1 && this.$store.getters.getComposerModules.postcard.message.mode === null) {
        this.errors.push({
          type: 'error',
          message: 'Bitte wählen Sie eine Option für die Grußkartentexte.',
          context: {
            module: 'postcard',
            anchor: '_ModulePostcardMessage'
          }
        });
      }

      // No postcard message given
      if (
        this.$store.getters.getComposerModules.postcard.main.mode === 1 &&
        (this.$store.getters.getComposerModules.postcard.message.mode === 1 || this.$store.getters.getComposerModules.postcard.message.mode === 2) &&
        (this.$store.getters.getComposerModules.postcard.message.option === 1 || this.$store.getters.getComposerModules.postcard.message.option === 0) &&
        this.$store.getters.getComposerModules.postcard.message.text === ''
      ) {
        this.errors.push({
          type: 'error',
          message: 'Sie müssen für Ihre Auswahl einen Grußkartentext angeben.',
          context: {
            module: 'postcard',
            modal: 'ModalPostcardMessageHandwritten'
          }
        });
      }

      // No shipping moode s
      if (this.$store.getters.getComposerModules.shipping.main.mode === null || ((this.$store.getters.getComposerModules.shipping.main.mode === 1 || this.$store.getters.getComposerModules.shipping.main.mode === 2) && this.boxQty > 1) || (this.$store.getters.getComposerModules.shipping.main.mode === 6 && this.boxQty < this.$store.getters.getOrderQtySize.sm.min)) {
        this.errors.push({
          type: 'error',
          message: 'Bitte wählen Sie eine Option für den Versand.',
          context: {
            module: 'shipping'
          }
        });
      }

      // No delayed shipping date given
      if (
        (this.$store.getters.getComposerModules.shipping.main.mode === 1 || this.$store.getters.getComposerModules.shipping.main.mode === 2) &&
        this.$store.getters.getComposerModules.shipping.single.option === '2' && this.$store.getters.getComposerModules.shipping.single.desiredShippingDate === ''
      ) {
        this.errors.push({
          type: 'error',
          message: 'Sie müssen für Ihre Auswahl ein Versanddatum auswählen.',
          context: {
            module: 'shipping'
          }
        });
      }

      // Individual: Address count mismatch for individual delivery and bulk and combined
      if (
        this.$store.getters.getComposerModules.shipping.main.mode === 3 && this.$store.getters.getComposerModules.shipping.individual.international && this.$store.getters.getSelectedQty !== this.$store.getters.getComposerModules.shipping.individual.regions.de + this.$store.getters.getComposerModules.shipping.individual.regions.eu + this.$store.getters.getComposerModules.shipping.individual.regions.ch_uk + this.$store.getters.getComposerModules.shipping.individual.regions.other
      ) {
        this.errors.push({
          type: 'error',
          message: 'Die ausgewählte Menge der Boxen passt nicht mit der Anzahl der ausgewählten Adressen zusammen.',
          context: {
            module: 'shipping',
            modal: 'ModalShippingIndividual'
          }
        });
      }

      // Bulk: Address count mismatch for individual delivery and bulk and combined
      if (
        this.$store.getters.getComposerModules.shipping.main.mode === 4 && this.$store.getters.getComposerModules.shipping.bulk.multipleLocations && this.$store.getters.getSelectedQty !== this.$store.getters.getComposerModules.shipping.bulk.regions.de + this.$store.getters.getComposerModules.shipping.bulk.regions.other
      ) {
        this.errors.push({
          type: 'error',
          message: 'Die ausgewählte Menge der Boxen passt nicht mit der Anzahl der ausgewählten Adressen zusammen.',
          context: {
            module: 'shipping',
            modal: 'ModalShippingBulk'
          }
        });
      }

      // Combined: Address count mismatch for individual delivery and bulk and combined
      if (
        (this.$store.getters.getComposerModules.shipping.main.mode === 5 && this.$store.getters.getComposerModules.shipping.combined.international && this.$store.getters.getSelectedQty !== this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.de + this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.eu + this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.ch_uk + this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.other + this.$store.getters.getComposerModules.shipping.combined.splitting.international.bulk.de + this.$store.getters.getComposerModules.shipping.combined.splitting.international.bulk.other) ||
        (this.$store.getters.getComposerModules.shipping.main.mode === 5 && !this.$store.getters.getComposerModules.shipping.combined.international && this.$store.getters.getSelectedQty !== this.$store.getters.getComposerModules.shipping.combined.splitting.national.single + this.$store.getters.getComposerModules.shipping.combined.splitting.national.bulk)
      ) {
        this.errors.push({
          type: 'error',
          message: 'Die ausgewählte Menge der Boxen passt nicht mit der Anzahl der ausgewählten Adressen zusammen.',
          context: {
            module: 'shipping',
            modal: 'ModalShippingCombined'
          }
        });
      }

      return this.errors;
    }
  }
};
